import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../../emotion-theme";

export const SearchSuggestListItem = styled.li`
  font-size: 14px;
  padding: 8px;
  font-weight: 400;
  width: 100%;
  color: ${BASE_COLORS.navyBlue};

  :hover {
    background-color: ${BASE_COLORS.navyBlue};
    color: ${BASE_COLORS.white};
    cursor: pointer;
  }
`;
